<template>
  <v-img contain src="@/assets/Color services.svg" width="34" height="34" />
</template>

<script>
  export default {
    name: 'ColorServices'
  }
</script>
